import { useState } from "react";
import ShareButtons from "./shareButtons";
import CountdownTimer from "./CountdownTimer";
import { Col, Row } from "antd";

const ShareOptions = ({ data }: any) => {
    const [showSocialMedia, setShowSocialMedia] = useState(false);

    const handleSocialMedia = () => {
        setShowSocialMedia(!showSocialMedia)
    };

    return (
        <div className="get-back">
            <Row gutter={[8, 24]} style={{ alignItems: "center" }}>
                <Col sm={24} md={12} lg={12}>
                    <CountdownTimer handleSocialMedia={handleSocialMedia} showSocialMedia={showSocialMedia} data={data} />
                </Col>
                {
                    showSocialMedia ? (
                        <Col sm={24} md={12} lg={12}>
                            <div className="social_networks">
                                <ShareButtons />
                            </div>
                        </Col>
                    ) : null
                }
            </Row>
        </div>
    );
};

export default ShareOptions;
